import React from 'react';

const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 26 26"
      version="1.1"
      viewBox="0 0 26 26"
    >
      <path
        id="icon-header-phone"
        d="m19.2 26c-0.6 0-1.2-0.1-2-0.2-3.5-0.8-7.3-3.3-11-7.1-0.1-0.1-3.9-3.9-5.5-8.5-0.3-1.2-1-3.8-0.4-5 0.4-0.9 1.5-1.9 2.6-3 0.2-0.1 0.3-0.2 0.4-0.3 0.5-0.5 1.3-1.3 2.3-1.7 0.2-0.1 0.4-0.2 0.6-0.2 0.8 0 1.4 0.7 2.3 2.8l2.2 4.1c0 0.1 0.3 1.3-0.7 2.4l-1 1c0.1 0.2 0.2 0.6 0.4 0.8 0.6 0.9 2.5 3.3 4 4.4 1.3 1 2 1.3 2.3 1.4 0.3-0.3 0.8-0.7 1.1-1l0.1-0.1c0.5-0.5 1.4-1.3 2.6-0.7 0.8 0.3 4.8 2.7 5.5 3.2 0.1 0.1 0.8 0.5 0.9 1.3 0.1 0.4 0 1-0.5 1.6-0.7 0.9-3 3.1-3.4 3.5-0.3 0.5-1 1.3-2.8 1.3zm-13.2-23.9c-0.5 0.3-1 0.8-1.3 1.1l-0.5 0.5c-0.6 0.6-1.9 1.7-2.2 2.3-0.2 0.4 0.1 2 0.5 3.5 1.5 4.1 5 7.7 5.1 7.7 3.4 3.6 6.9 5.9 10 6.6 1.9 0.4 2.7 0.1 2.8-0.1l0.1-0.2 3.4-3.4v-0.1c-1.8-1.1-4.8-2.9-5.3-3.1-0.2 0-0.4 0.2-0.6 0.4l-0.1 0.1c-0.5 0.5-1.5 1.3-1.5 1.3l-0.2 0.2h-0.3c-0.9 0.1-2.1-0.4-3.9-1.9-1.9-1.5-4-4.2-4.4-4.9-0.6-0.9-0.6-2-0.6-2.2v-0.4l0.3-0.3s0.6-0.6 1.3-1.2c0.2-0.2 0.2-0.4 0.3-0.5l-2-3.8c-0.4-0.8-0.7-1.3-0.9-1.6z"
        fill="#fff"
      />
    </svg>
  );
};

export default PhoneIcon;
